








































import { TaskStatusTypes } from "@/models/task-status";
import {
  searchServiceTask,
  SearchServiceTaskQuery,
  ServiceTask
} from "@/servicetask/api/service-tasks-api";
import { Prop, Component, Vue } from "vue-property-decorator";
import SearchTaskList, { ListItem } from "../components/SearchTaskList.vue";

@Component({
  components: {
    SearchTaskList
  },
  model: {
    prop: "open"
  }
})
export default class SearchTaskModal extends Vue {
  @Prop({ type: Boolean }) open!: boolean;
  @Prop({ required: true }) serviceTaskTypeId!: number;
  @Prop({ default: "" }) specialKeyword!: string;

  items: ListItem[] = [];
  query: Partial<SearchServiceTaskQuery> = {
    keyword: "",
    status: ""
  };
  taskStatusOptions = [
    {
      text: "全ての状態",
      value: ""
    }
  ].concat(
    TaskStatusTypes.map(t => ({
      text: t,
      value: t
    }))
  );

  reset() {
    this.items = [];
    this.query = { keyword: this.specialKeyword, status: "" };
    this.$nextTick(() => {
      // 確実にpropsを読み取れるようにnextTickで処理する
      this.search();
    });
  }

  async search() {
    const query = {
      serviceTaskTypeId: this.serviceTaskTypeId,
      keyword: [this.query.keyword].join(" ").trim(),
      status: this.query.status
    };
    this.items = (await searchServiceTask(query)).map(TaskListItem);
  }
}

function TaskListItem(item: ServiceTask): ListItem {
  return {
    id: item.id,
    projectId: item.project.id,
    projectName: item.project.name,
    task: item.name,
    status: item.status,
    operator: (item.project.staff && item.project.staff.name) || "",
    client: (item.client && item.client.name) || "",
    director:
      (item.client && item.client.staff && item.client.staff.name) || "",
    date: item.startDate,
    _rowVariant: item.status === "保留" ? "danger" : ""
  };
}
